<template>
<div class="main-nav js-main-nav" :class="{'is--loaded': loaded }">
  <a href="/" class="main-nav--logo">
    <img v-if="logo_url" alt="logo image" :src="logo_url">
  </a>
  <ul class="main-nav--list">
    <li><a href="/search">{{$store.getters.language.rent}}</a></li>
    <li @mouseover="subActive = 'language'" @mouseleave="subActive = null" @click="subActive = 'language'" :class="{ 'is--hovered': subActive === 'language' }">
      <a href="#">{{ current_locale }} <span class="main-nav--arr"></span></a>
      <ul class="main-nav--subnav">
        <li><a href="/home/switch?locale=en">English</a></li>
        <li><a href="/home/switch?locale=es">Español</a></li>
<!--        <li><a href="/home/switch?locale=it">Italiano</a></li>-->
      </ul>
    </li>
    <li @mouseover="subActive = 'resources'" @mouseleave="subActive = null" @click="subActive = 'resources'" :class="{ 'is--hovered': subActive === 'resources' }">
      <a href="#">{{$store.getters.language.resources}} <span class="main-nav--arr"></span></a>
      <ul class="main-nav--subnav">
        <li v-if="organisation_name == 'Nhood'"><a href="/es/landlord">{{$store.getters.language.landlord}}</a></li>
        <li><a href="/es/contact">{{$store.getters.language.contact}}</a></li>
      </ul>
    </li>
    <template v-if="user && user.teams && user.teams.length > 0">
    <li @mouseover="subActive = 'teams'" @mouseleave="subActive = null" @click="subActive = 'teams'" :class="{ 'is--hovered': subActive === 'teams' }">
      <a href="#">{{ activeTeam }} <span class="main-nav--arr"></span></a>
      <ul class="main-nav--subnav">
        <li v-for="(team, t) in user.teams" :key="t"><a :href="team.url">{{ team.name }}</a></li>
      </ul>
    </li>
    </template>

    <li v-if="has_session && cart_count > 0" class="main-nav--has-unread"><a href="/search/cart"><img src="/assets/cart_icon.svg"></a></li>

    <li v-if="!has_session"><a href="/users/sign_in">{{$store.getters.language.login}}</a></li>
    <li v-if="!has_session"><a href="/signup">{{$store.getters.language.sign_up}}</a></li>
    <li v-if="has_session" @mouseover="subActive = 'account'" @mouseleave="subActive = null" @click="subActive = 'account'" :class="{ 'is--hovered': subActive === 'account' }">
      <a class="main-nav--account" href="#">
      <div class="main-nav--lines">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="main-nav--avatar">
        <img :src="has_session && picture_url ? picture_url : '/assets/avatar.svg' " alt="Avatar">
      </div>
    </a>
    <ul class="main-nav--subnav">
      <li v-if="user && user.is_landlord"><a href="/dashboard/information">Data Management</a></li>
      <li><a href="/dashboard/bookings">{{$store.getters.language.bookings}}</a></li>
      <li v-if="user && user.is_landlord"><a href="/dashboard/calendar">{{$store.getters.language.calendar}}</a></li>
      <li><a href="/dashboard/messages">{{$store.getters.language.messages}} </a></li>
      <li><a v-if="user && !user.is_landlord" href="/dashboard/saved-spaces">Saved Spaces</a></li>
      <li v-if="user && user.is_landlord"><a href="/dashboard/create-link">{{$store.getters.language.create_link}}</a></li>
      <li v-if="user && user.is_landlord"><a href="/users/listings">{{$store.getters.language.my_spaces}}</a></li>
      <li v-if="has_session && organisation_name != 'Nhood'"><a href="/payments/payments_in">{{$store.getters.language.account}}</a></li>
      <li><a href="/teams">{{$store.getters.language.teams}}</a></li>
      <li v-if="has_session && switch_back_id"><a :href="has_session && (switch_back_id === 'multiple' ) ? '/teams' : `/teams/switch_team_user?user_id=#${ switch_back_id }` ">{{$store.getters.language.switch_to}}</a></li>
      <li v-if="user && !user.is_landlord"><a href="/dashboard/profile">{{$store.getters.language.profile}}</a></li>
      <li class="main-nav--separator"></li>
      <li class="main-nav--highlight"><a data-method="delete" href="/users/sign_out">{{$store.getters.language.logout}}</a></li>
    </ul>
  </li>
  </ul>

  <a @click.prevent="mobileHover = !mobileHover, subActive = false" class="main-nav--trigger" href="#">
  <div class="main-nav--lines">
    <span></span>
    <span></span>
    <span></span>
  </div>
  </a>

  <a v-if="has_session && cart_count > 0" class="main-nav--mobile-cart" href="/search/cart"><img src="/assets/cart_icon.svg"></a>

  <div :class="{ 'is--hovered': mobileHover }" class="main-nav--list-mobile">
      <div class="main-nav--mobile-menu">
        <ul class="main-nav--parent" :class="{ 'is--hidden': subActive }">
        <li v-if="user && user.is_landlord"><a href="/dashboard/information">Data Management</a></li>
        <li v-if="has_session" :class="has_session && bookings_count && bookings_count > 0 ? 'main-nav--has-unread' : null"><a href="/users/bookings">{{$store.getters.language.bookings}} <span v-if="has_session && bookings_count && bookings_count > 0" class="main-nav--unread">{{ bookings_count }} new</span></a></li>
        <li v-if="has_session" :class="has_session && messages_count && messages_count > 0 ? 'main-nav--has-unread' : null"><a href="/users/bookings">{{$store.getters.language.messages}} <span v-if="has_session && messages_count && messages_count > 0" class="main-nav--unread">{{ messages_count }} new</span></a></li>
        <li v-if="has_session"><a href="/dashboard/create-link">Create Link</a></li>
        <li v-if="has_session"><a href="/users/listings">My Spaces</a></li>
        <li><a href="/dashboard/saved-spaces">Saved Spaces</a></li>
        <li v-if="has_session && organisation_name != 'Nhood'"><a href="/payments/payments_in">{{$store.getters.language.account}}</a></li>
        <li v-if="has_session"><a href="/teams">{{$store.getters.language.teams}}</a></li>
        <li v-if="has_session && switch_back_id"><a :href="has_session && (switch_back_id === 'multiple' ) ? '/teams' : `/teams/switch_team_user?user_id=#${ switch_back_id }` ">{{$store.getters.language.switch_to}}</a></li>
        <li v-if="has_session" class="main-nav--separator"></li>
        <li :class="{'is--current': this.$router.currentRoute.name === 'Centre' || this.$router.currentRoute.name === 'Rent'}"><a href="/search">{{$store.getters.language.rent}}</a></li>
        <li>
          <a @click.prevent="subActive = 'language'" href="#">{{$store.getters.language.language}} <span class="main-nav--arr main-nav--arr--right"></span></a>
        </li>
        <li>
          <a @click.prevent="subActive = 'resources'" href="#">Resources <span class="main-nav--arr main-nav--arr--right"></span></a>
        </li>
        <li  v-if="user && !user.is_landlord"><a href="/dashboard/profile">{{$store.getters.language.profile}}</a></li>
        <li v-if="has_session" class="main-nav--separator"></li>
        <li v-if="has_session" class="main-nav--highlight"><a href="/users/sign_out" data-method="delete">{{$store.getters.language.logout}}</a></li>
        <li v-if="!has_session"><a href="/users/sign_in">{{$store.getters.language.login}}</a></li>
      </ul>

      <ul :class="{ 'is--expanded': subActive === 'resources' }" class="main-nav--child">
        <li class="main-nav--back"><a @click.prevent="subActive = null" href="#"><span class="main-nav--back-arr"></span></a></li>
        <li v-if="organisation_name == 'Nhood'"><a href="/es/landlord">{{$store.getters.language.landlord}}</a></li>

<!--        <li v-if="organisation_name != 'Nhood'"><a href="https://pages.fillit.com">Blog</a></li>-->
<!--        <li v-if="organisation_name != 'Nhood'"><a href="/es/about">{{$store.getters.language.about}}</a></li>-->
<!--        <li v-if="organisation_name != 'Nhood'"><a target="_blank" href="http://help.fillit.ie/en/">{{$store.getters.language.help}}</a></li>-->
        <li><a href="/es/contact">{{$store.getters.language.contact}}</a></li>
      </ul>

      <ul :class="{ 'is--expanded': subActive === 'language' }" class="main-nav--child">
        <li class="main-nav--back"><a @click.prevent="subActive = null" href="#"><span class="main-nav--back-arr"></span></a></li>
        <li><a href="/home/switch?locale=en">English</a></li>
        <li><a href="/home/switch?locale=es">Español</a></li>
<!--        <li><a href="/home/switch?locale=it">Italiano</a></li>-->
      </ul>

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SiteNav',
  data: () => ({
    subActive: null,
    mobileHover: false,
    organisation_name: 'Fillit',
    has_session: false,
    bookings_count: 0,
    messages_count: 0,
    cart_count: 0,
    picture_url: null,
    logo_url: null,
    switch_back_id: null,
    is_landlord: null,
    loaded: false,
    user: null,
    current_locale: null
  }),
  components: {
  },
  watch: {
  },
  created () {
    this.getUser()
  },
  computed: {
    activeTeam: function () {
      if (this.user && this.user.teams.length > 0) {
          var active = null
          this.user.teams.forEach((team) => {
              if (team.is_active) {
                  active = team.name
              }
          })
          if (!active) {
              active = this.user.first_name
          }
          return active
      }
    }
  },
  mounted () {
    this.current_locale = current_locale
  },
  methods: {
    getUser() {
        var self = this
        axios
            .get('/api/searches/get_user')
            .then(response => {
                self.loaded = true
                if (response.data.response == true) {
                    self.has_session = true
                    self.messages_count = response.data.messages_count
                    self.cart_count = response.data.cart_count
                    self.bookings_count = response.data.bookings_count
                    self.picture_url = response.data.picture_url
                    self.logo_url = response.data.logo_url
                    self.switch_back_id = response.data.switch_back_id
                    self.is_landlord = response.data.is_landlord
                    self.user = response.data
                    self.organisation_name = response.data.organisation_name
                } else {
                  self.logo_url = response.data.logo_url
                }
            })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.main-nav {
  height: 70px;
  border: none;
  background: #ffffffd9;
  // box-shadow: 0px 1px 3px 1px #D7D7D7;
  padding: 0 120px;
  display: grid;
  align-items: center;
  grid-template-columns: 120px auto;
  z-index: 1100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  &.is--loaded {
    opacity: 1;
  }
  @include breakpoint(desktop) {
    padding: 0 80px;
  }
  @include breakpoint(tablet) {
    padding: 0 24px;
  }
}
.main-nav--logo {
  img {
    width: 62px;
    display: block;
  }
}
.main-nav--trigger {
  display: none;
  width: 48px;
  height: 70px;
  position: absolute;
  right: 20px;
  top: 0px;
  box-size: border-box;
  padding: 24px 15px;
  @include breakpoint(tablet) {
    display: block;
  }
  span {
    display: block;
    width: 18px;
    height: 2px;
    background: $strong-light;
    border-radius: 0;
    margin-bottom: 3px;
    @include ease-fast;
  }
}

.main-nav--mobile-cart {
  display: none;
  position: absolute;
  right: 65px;
  top: 0px;
  box-size: border-box;
  padding: 17px 10px;
  height: 70px;
  &:after {
    content: "";
    height: 5px;
    width: 5px;
    border-radius: 5px;
    background: $primary;
    display: inline-block;
    vertical-align: top;
    margin-left: 1px;
    color: $grey-m;
  }
  img {
    width: 16px;
  }
  @include breakpoint(tablet) {
    display: block;
  }
}

.main-nav--list, .main-nav--list-mobile {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  padding: 0;
  height: 100%;
  list-style: none;
  @include breakpoint(tablet) {
    display: none;
  }

  .main-nav--account {
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 4px;
    gap: 10px;
    border: 0px solid $mid-light;
    padding: 0px 10px 0px 0px!important;
    margin: 10px 0px 10px 20px;

    &.main-nav--account-trigger {
      border: 0px;
      border-radius: 0px;
      padding: 10px;
    }

    @include breakpoint(desktop) {
      border-radius: 20px;
      padding: 4px 10px 4px 4px;
    }

    .main-nav--avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .main-nav--lines {
      width: 28px;
      padding: 5px;

      span {
        width: 100%;
        margin-bottom: 3px;
        background: $primary-grey;
        height: 2px;
        display: block;
        border-radius: 1px;

        &:last-child {
          margin: 0;
        }
      }
    }

  }

  .main-nav--subnav {
    margin: 0;
    padding: 8px 0;
    opacity: 0;
    text-align: left;
    position: absolute;
    top: 100%;
    right: 0%;
    min-width: 220px;
    @include transform(translate(0, 0));
    list-style: none;
    pointer-events: none;
    @include ease-fast;
    background: #FFFFFF;
    box-shadow: 0px 1px 3px 1px #D7D7D7;
    border-radius: 4px;
    max-height: 650px;
    overflow: scroll;
    // Hide scrollbars
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;     /* Firefox */
    &::-webkit-scrollbar {
      display: none;             /* Chrome, Safari */
    }
    
    a  {
      padding: 16px 24px;
    }
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    position: relative;
    @include responsive-text-size('Header--13--BOLD');
    list-style: none;

    &.is--hovered {
      .main-nav--subnav {
        opacity: 1;
        pointer-events: auto;

        a {
          @include ease-fast;
          &:hover {
            background: $light-grey;
          }
        }
      }
    }
  }

  a {
    position: relative;
    display: block;
    padding: 10px 20px;
    color: $primary-grey;
    transition: 200ms ease-in-out;
  }

  .main-nav--has-unread {
    a {
      &:after {
        content: "";
        height: 5px;
        width: 5px;
        border-radius: 5px;
        background: $primary;
        display: inline-block;
        vertical-align: top;
        margin-left: 1px;
        color: $grey-m;
      }
    }
    img{
      width: 16px;
    }
  }

  .main-nav--unread {
    position: absolute;
    right: 15px;
    top: 50%;
    @include transform(translate(0, -50%));
    font-family: $font-regular;
    text-transform: lowercase;
  }

  .main-nav--action-button {
    margin-left: 25px;
    font-family: $font-bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15px 0px;
    width: 160px;
    border-radius: 100px;
    color: #FFFFFF;
    background: $primary;
    border: 1px solid $primary;
    outline: none;
    @include ease-fast;

    @include breakpoint(desktop) {
        margin-left: 20px;
      }

    &:hover {
      background: #FFFFFF;
      color: $primary;
    }
  }

  .main-nav--highlight {
    a {
      color: $primary;
    }
  }

  .main-nav--separator {
    height: 1px;
    width: calc(100% - 20px);
    background: #BFBFBF;
    margin: 5px 10px;
  }

}


.main-nav--has-dropdown {
  position: relative;
  &:hover {
    .main-nav--dropdown {
      display: block;
    }
  }
}
.main-nav--dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 0;
  margin: -6px 0 0 0;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.18);
  li {
    border-bottom: 1px solid #e5e5e5;
    &:last-child {
      border: 0;
    }
  }
  a {
    text-align: center;
    padding: 15px 0;
    margin: 0;
    color: $mid-dark;
    transition: 200ms ease-in-out;
    display: block;
  }
}

.main-nav--list-mobile {
  display: none;
  pointer-events: none;
  transform: translate(102%, 0);
  width: 90%;
  max-width: 327px;
  position: fixed;
  top: 70px;
  right: 0;
  bottom: 0;
  background: #FFFFFF;
  z-index: 1009;
  align-items: flex-start;
  transition: transform 0.6s ease-in-out;
  box-shadow: 0px 1px 3px 1px $mid-light;
  border-radius: 4px 0px 0px 4px;
  @include breakpoint(tablet) {
    display: flex;

    &.is--hovered {
      transform: translate(0%, 0);
      pointer-events: auto;
    }

  }
}

.main-nav--mobile-menu {
  list-style: none;
  width: 200px;
  padding: 8px 0;

  li {
    a {
      padding: 2vh 10px 2vh 20px;
      @include ease-fast;
      &:hover {
        background: $light-grey;
      }
    }
  }
}

.main-nav--arr {
  display: inline-block;
  height: 7px;
  width: 10px;
  background: url(/assets/menu-arrow.svg);
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;

  &.main-nav--arr--right {
    @include transform(rotate(-90deg));
  }
  &.main-nav--arr--left {
    @include transform(rotate(90deg));
  }
}


.main-nav--child {
  height: 0;
  overflow: hidden;
  opacity: 0;
  @include ease-fast;
  &.is--expanded {
    opacity: 1;
    height: auto;
  }
}

.main-nav--parent {
  @include ease-fast;
  &.is--hidden {
    height: 0;
    overflow: hidden;
    opacity: 0;
  }
}

.main-nav--back {
  margin-bottom: 20px;
}

.main-nav--back-arr {
  display: block;
  height: 7px;
  width: 10px;
  background: url(/assets/menu-arrow.svg);
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0;
  @include transform(rotate(90deg));
}

.alert_head {
    display: none!important;
}

.floating--menu {
  .main_wrap {
    padding: 0;
  }
  
  .main-nav {
    background: rgba(255,255,255,0.85);
    box-shadow: none;
    top: 16px;
    left: 16px;
    right: 16px;
    border-radius: 10px;
    padding: 0 24px;
    height: 56px;
  }

  .main-nav--trigger {
      height: 56px;
      padding: 22px 0px;
      right: 0px;
  }

}

</style>
